/**
 * Предоставляет общие методы и свойства для работы с уведомлениями.
 * Этот сервис предоставляет общую функциональность для работы с уведомлениями,
 * такую как определение размера и типа устройства, а также методы для отображения,
 * закрытия и закрытия всех уведомлений.
 */

export class CommonService {
  constructor(gaApp, needClean) {
    this.gaApp = gaApp
    this.needClean = needClean
  }

  // Возвращает строку с шириной в `px` для мобильных устройств
  get widthMobile() {
    return `${this.windowInnerWidth - 40}px`
  }

  // возвращает ширину внутренней области окна браузера
  get windowInnerWidth() {
    return this.gaApp.stores.app.window?.windowSize?.innerWidth || 360
  }

  // Отображает уведомление с указанными параметрами
  show(options) {
    this.gaApp.libs.notifier.open(options)
  }

  // Закрывает уведомление с указанным идентификатором
  close(id) {
    this.gaApp.libs.notifier.close(id)
  }

  // Закрывает все открытые уведомления
  closeAll() {
    this.gaApp.libs.notifier.closeAll()
  }
}
